export const getMobileRouteType = () => {
  const config: any = sessionStorage.getItem('globalLiveConfig')
  if (config) {
    return JSON.parse(config)?.mobileRoute || 'Mobile'
  } else {
    return 'Mobile'
  }
}
